/* tslint:disable */
/* eslint-disable */
/**
 * Muscula App API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiErrorResponse,
  LoginLocalRequest,
  LoginSocialRequest,
  RegisterUserLocalRequest,
  ResetPasswordRequest,
  SuccessfullApiResponse,
  UserBasicInfoGenericApiResponse,
  UserListDto,
  UserStatsResponseListGenericApiResponse,
} from '../models';
import {
    ApiErrorResponseFromJSON,
    ApiErrorResponseToJSON,
    LoginLocalRequestFromJSON,
    LoginLocalRequestToJSON,
    LoginSocialRequestFromJSON,
    LoginSocialRequestToJSON,
    RegisterUserLocalRequestFromJSON,
    RegisterUserLocalRequestToJSON,
    ResetPasswordRequestFromJSON,
    ResetPasswordRequestToJSON,
    SuccessfullApiResponseFromJSON,
    SuccessfullApiResponseToJSON,
    UserBasicInfoGenericApiResponseFromJSON,
    UserBasicInfoGenericApiResponseToJSON,
    UserListDtoFromJSON,
    UserListDtoToJSON,
    UserStatsResponseListGenericApiResponseFromJSON,
    UserStatsResponseListGenericApiResponseToJSON,
} from '../models';

export interface ApiUserAuthLoginPostRequest {
    loginLocalRequest?: LoginLocalRequest;
}

export interface ApiUserAuthRegisterPostRequest {
    registerUserLocalRequest?: RegisterUserLocalRequest;
}

export interface UserAuthChangepasswordPostRequest {
    body?: string;
}

export interface UserAuthChangepasswordwithtokenPostRequest {
    resetPasswordRequest?: ResetPasswordRequest;
}

export interface UserAuthConfirmemailGetRequest {
    userId?: string;
    token?: string;
}

export interface UserAuthGooglePostRequest {
    loginSocialRequest?: LoginSocialRequest;
}

export interface UserAuthMicrosoftPostRequest {
    loginSocialRequest?: LoginSocialRequest;
}

export interface UserAuthSendpasswordtokenPostRequest {
    email?: string;
}

/**
 * 
 */
export class UserAuthApi extends runtime.BaseAPI {

    /**
     */
    async apiUserAuthAcceptTermsOfUsePutRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/UserAuth/AcceptTermsOfUse`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiUserAuthAcceptTermsOfUsePut(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiUserAuthAcceptTermsOfUsePutRaw(initOverrides);
    }

    /**
     */
    async apiUserAuthLoginPostRaw(requestParameters: ApiUserAuthLoginPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SuccessfullApiResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/UserAuth/Login`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LoginLocalRequestToJSON(requestParameters.loginLocalRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessfullApiResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiUserAuthLoginPost(requestParameters: ApiUserAuthLoginPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SuccessfullApiResponse> {
        const response = await this.apiUserAuthLoginPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiUserAuthRegisterPostRaw(requestParameters: ApiUserAuthRegisterPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserBasicInfoGenericApiResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/UserAuth/Register`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RegisterUserLocalRequestToJSON(requestParameters.registerUserLocalRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserBasicInfoGenericApiResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiUserAuthRegisterPost(requestParameters: ApiUserAuthRegisterPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserBasicInfoGenericApiResponse> {
        const response = await this.apiUserAuthRegisterPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiUserAuthSignOutDeleteRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SuccessfullApiResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/UserAuth/SignOut`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessfullApiResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiUserAuthSignOutDelete(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SuccessfullApiResponse> {
        const response = await this.apiUserAuthSignOutDeleteRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async apiUserAuthTestGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SuccessfullApiResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/UserAuth/Test`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessfullApiResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiUserAuthTestGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SuccessfullApiResponse> {
        const response = await this.apiUserAuthTestGetRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async apiUserAuthUsersGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UserListDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/UserAuth/Users`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UserListDtoFromJSON));
    }

    /**
     */
    async apiUserAuthUsersGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UserListDto>> {
        const response = await this.apiUserAuthUsersGetRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async userAuthChangepasswordPostRaw(requestParameters: UserAuthChangepasswordPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SuccessfullApiResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/UserAuth/changepassword`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessfullApiResponseFromJSON(jsonValue));
    }

    /**
     */
    async userAuthChangepasswordPost(requestParameters: UserAuthChangepasswordPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SuccessfullApiResponse> {
        const response = await this.userAuthChangepasswordPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async userAuthChangepasswordwithtokenPostRaw(requestParameters: UserAuthChangepasswordwithtokenPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SuccessfullApiResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/UserAuth/changepasswordwithtoken`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ResetPasswordRequestToJSON(requestParameters.resetPasswordRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessfullApiResponseFromJSON(jsonValue));
    }

    /**
     */
    async userAuthChangepasswordwithtokenPost(requestParameters: UserAuthChangepasswordwithtokenPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SuccessfullApiResponse> {
        const response = await this.userAuthChangepasswordwithtokenPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async userAuthConfirmemailGetRaw(requestParameters: UserAuthConfirmemailGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters.userId !== undefined) {
            queryParameters['userId'] = requestParameters.userId;
        }

        if (requestParameters.token !== undefined) {
            queryParameters['token'] = requestParameters.token;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/UserAuth/confirmemail`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userAuthConfirmemailGet(requestParameters: UserAuthConfirmemailGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.userAuthConfirmemailGetRaw(requestParameters, initOverrides);
    }

    /**
     */
    async userAuthDeleteRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SuccessfullApiResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/UserAuth`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessfullApiResponseFromJSON(jsonValue));
    }

    /**
     */
    async userAuthDelete(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SuccessfullApiResponse> {
        const response = await this.userAuthDeleteRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async userAuthGooglePostRaw(requestParameters: UserAuthGooglePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SuccessfullApiResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/UserAuth/google`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LoginSocialRequestToJSON(requestParameters.loginSocialRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessfullApiResponseFromJSON(jsonValue));
    }

    /**
     */
    async userAuthGooglePost(requestParameters: UserAuthGooglePostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SuccessfullApiResponse> {
        const response = await this.userAuthGooglePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async userAuthMicrosoftPostRaw(requestParameters: UserAuthMicrosoftPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SuccessfullApiResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/UserAuth/microsoft`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LoginSocialRequestToJSON(requestParameters.loginSocialRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessfullApiResponseFromJSON(jsonValue));
    }

    /**
     */
    async userAuthMicrosoftPost(requestParameters: UserAuthMicrosoftPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SuccessfullApiResponse> {
        const response = await this.userAuthMicrosoftPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async userAuthSendpasswordtokenPostRaw(requestParameters: UserAuthSendpasswordtokenPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SuccessfullApiResponse>> {
        const queryParameters: any = {};

        if (requestParameters.email !== undefined) {
            queryParameters['email'] = requestParameters.email;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/UserAuth/sendpasswordtoken`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessfullApiResponseFromJSON(jsonValue));
    }

    /**
     */
    async userAuthSendpasswordtokenPost(requestParameters: UserAuthSendpasswordtokenPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SuccessfullApiResponse> {
        const response = await this.userAuthSendpasswordtokenPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async userAuthStatsGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserStatsResponseListGenericApiResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/UserAuth/stats`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserStatsResponseListGenericApiResponseFromJSON(jsonValue));
    }

    /**
     */
    async userAuthStatsGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserStatsResponseListGenericApiResponse> {
        const response = await this.userAuthStatsGetRaw(initOverrides);
        return await response.value();
    }

}
